import React from 'react';
import FieldSelect from './FieldSelect.jsx';

export default function FieldSelectDriveability(props) {
  const options = [
    { slug: 5, value: '5 - Exceptional' },
    { slug: 4, value: '4 - Above Average' },
    { slug: 3, value: '3 - Average' },
    { slug: 2, value: '2 - Below Average' },
    { slug: 1, value: '1 - Poor' },
  ];

  return (
    <FieldSelect
      {...props}
      field="trackDriveability"
      options={options}
    />
  );
}
